import React, { useContext, useEffect, useState } from "react";
import ActionTable from "../../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import Form from "../../../components/form";
import serverHost from "../../../services/serverHost";
let palavra = "";
export default function Pronuncias({ unidadeId }) {
  const [carregando, setCarregando] = useState(false);
  const [lista, setLista] = useState([]);
  const [pronunciasAdicionar, setPronunciasAdicionar] = useState([]);
  const [pronunciaSelecionada, setPronunciaSelecionada] = useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarPronunciasUnidade();
  }, []);

  const carregarPronunciasUnidade = () => {
    setCarregando(true);
    api
      .get("unidades/listarPronuncias", { unidadeId: unidadeId })
      .then((pronuncias) => {
        setCarregando(false);

        pronuncias.forEach((p) => {
          p.previaImagem = p.imagem ? `${serverHost()}/${p.imagem}` : "";
        });
        setLista(pronuncias);
      })
      .catch((err) => notification("error", "Erro ao carregar pronúncias "));
  };

  const buscarPronuncias = (form) => {
    palavra = form.palavra;
    setCarregando(true);

    api
      .get("pronuncias/listar", { palavra: form.palavra })
      .then((res) => {
        setCarregando(false);
        if (res.length === 0) {
          notification("warning", "Nenhum resultado para a busca");
        }
        setPronunciasAdicionar(res);
      })
      .catch((err) => notification("error", "Erro ao buscar pronúncias "));
  };

  const vincularPronuncia = (pronunciaId) => {
    api
      .post("unidades/vincularPronuncia", {
        unidadeId: unidadeId,
        pronunciaId: pronunciaId.id,
      })
      .then((res) => {
        if (res) {
          notification("success", "Pronúncia vinculada!");
          setPronunciasAdicionar([]);
          carregarPronunciasUnidade();
        }
      })
      .catch((err) => {
        const { data } = err;

        switch (data[0]) {
          case 1:
            return notification("error", "Unidade inválida");
          case 2:
            return notification("error", "Pronúncia inválida");
          case 3:
            return notification("error", "Vínculo já existente");
          default:
            return notification("error", "Erro ao vincular pronúncia");
        }
      });
  };

  const filtros = {
    title: "Incluir Pronúncia",
    form: {
      palavra: {
        label: "Palavra",
        type: "text",
        value: palavra,
      },
    },

    submit: {
      label: "Buscar",
      action: buscarPronuncias,
    },
  };

  const abrirPonuncia = (pronuncia) => {
    setPronunciaSelecionada(pronuncia);
  };

  const tPronuncias = {
    title: "Pronúncias localizadas",
    columns: [
      {
        name: "palavra",
        label: "Palavra",
      },
      {
        name: "descricao",
        label: "Descrição",
        type: "text",
      },
      {
        name: "voz",
        label: "Voz",
      },
    ],
    actions: [
      {
        name: "plus-circle",
        icon: "zmdi zmdi-plus-circle",
        action: vincularPronuncia,
      },
    ],
    array: pronunciasAdicionar,
  };

  const tRegistros = {
    title: "Pronúncias Da Unidade",
    onLineClick: abrirPonuncia,
    columns: [
      {
        name: "palavra",
        label: "Palavra",
      },
      {
        name: "ordem",
        label: "Ordem",
      },
    ],
    array: lista,
  };

  const editarPronuncia = (formulario) => {
    api
      .post("unidades/editarPronuncia", {
        unidadeId: unidadeId,
        pronunciaId: pronunciaSelecionada.id,
        ordem: formulario.ordem,
      })
      .then((res) => {
        notification("success", "Pronúncia editada");
        setPronunciaSelecionada({});
        carregarPronunciasUnidade();
      })
      .catch((err) => notification("error", "Erro ao editar pronúncia "));
  };

  const desvincularPronuncia = () => {
    api
      .post("unidades/desvincularPronuncia", {
        unidadeId: unidadeId,
        pronunciaId: pronunciaSelecionada.id,
      })
      .then((res) => {
        notification("success", "Pronúncia removida");
        setPronunciaSelecionada({});
        carregarPronunciasUnidade();
      })
      .catch((err) => {
        notification("error", "Não possível foi remover a pronúncia.");
      });
  };

  const fEditar = {
    title: "Pronúncia vinculada",
    form: {
      palavra: {
        label: "Palavra",
        type: "text",
        value: pronunciaSelecionada.palavra,
        enabled: false,
        space: 4,
        readOnly: true,
      },
      ordem: {
        label: "Ordem",
        type: "number",
        value: pronunciaSelecionada.ordem,
        space: 4,
      },
      player: {
        type: "component",
        value: (
          <audio
            preload="none"
            src={`${serverHost()}/${pronunciaSelecionada.audio}`}
            controls
          />
        ),
        space: 4,
      },
    },
    submit: {
      label: "Salvar",
      action: editarPronuncia,
    },

    close: {
      label: "Fechar",
      action: () => setPronunciaSelecionada({}),
    },

    customActions: [
      {
        label: "Excluir",
        action: desvincularPronuncia,
      },
    ],
  };

  return (
    <div>
      {pronunciaSelecionada.id ? (
        <>{carregando ? <CircularProgress /> : <Form formData={fEditar} />}</>
      ) : (
        <>
          <Form formData={filtros} />
          <br />
          <ActionTable structure={tPronuncias} />

          <br />
          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      )}
    </div>
  );
}
